// extracted by mini-css-extract-plugin
export default {"dialog":"ConfirmationDialog_dialog__FrHD2","confirmButton":"ConfirmationDialog_confirmButton__VUowL","cancelButton":"ConfirmationDialog_cancelButton__AFEZv"};